export default "__VITE_ASSET__D450o63Y__"